import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { styled } from "@mui/material";
const StyleBackWrapper = styled("div")(({ theme }) => {
    return {
        "&.UHF": {
            color: "var(--UHF-theme-color)",
        },
        "&.NETWELL": {
            color: "var(--NETWELL-btn-color)",
        },
        "&:hover": {
            cursor: "pointer",
        },
        textDecoration: "none",
        fontFamily: "Lato",
        fontWeight: 600,
        fontSize: 20,
        letterSpacing: 1.14,
        display: "flex",
        alignItems: "center",
        margin: "25px 0",
        svg: {
            marginRight: 5,
        },
        [theme.breakpoints.down(475)]: {
            display: "none",
        },
    };
});
export const BackArrow = (props) => {
    return (React.createElement(StyleBackWrapper, { onClick: props.onCallback, className: `${props.brand} new_back_page` },
        React.createElement(ArrowBackIcon, null),
        "BACK"));
};
